import { formatDisplayDate, parseFlexibleDate } from '../../../utils/dateUtils';

export const formatDateDisplay = (value, fallback = '') => {
  const parsed = parseFlexibleDate(value);
  if (!parsed) return fallback;
  return formatDisplayDate(parsed, { fallback });
};

export const formatDate = (value, { fallback = 'N/A' } = {}) => formatDateDisplay(value, fallback) || fallback;

export const dateSortComparator = (key) => (_v1, _v2, cellParams1, cellParams2) => {
  const left = cellParams1?.row?.[key];
  const right = cellParams2?.row?.[key];
  if (left === right) return 0;
  if (left === null || left === undefined) return -1;
  if (right === null || right === undefined) return 1;
  return left - right;
};

